module.exports = __webpack_public_path__ + "img/profileReplace.c9e5b9ae.svg";